var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5002V15.0002H5.00004V12.5002H3.33337V15.0002C3.33337 15.9168 4.08337 16.6668 5.00004 16.6668H15C15.9167 16.6668 16.6667 15.9168 16.6667 15.0002V12.5002H15ZM14.1667 9.16683L12.9917 7.99183L10.8334 10.1418V3.3335H9.16671V10.1418L7.00837 7.99183L5.83337 9.16683L10 13.3335L14.1667 9.16683Z",
    fill: "#6271DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/FileDownload.afc6414bc9e1d24ea0e3fe50926dfcef.svg";
export { ForwardRef as ReactComponent };